var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBatteryWarningVertical = function SvgIconBatteryWarningVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375.125a1 1 0 0 0 0 2h5.25a1 1 0 1 0 0-2zM12 8a1 1 0 0 1 1 1v3.75a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M13.5 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 3.5A2.5 2.5 0 0 0 4.25 6v13.875a2.5 2.5 0 0 0 2.5 2.5h10.5a2.5 2.5 0 0 0 2.5-2.5V6a2.5 2.5 0 0 0-2.5-2.5zM6.25 6a.5.5 0 0 1 .5-.5h10.5a.5.5 0 0 1 .5.5v13.875a.5.5 0 0 1-.5.5H6.75a.5.5 0 0 1-.5-.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBatteryWarningVertical;